<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="handSearch" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update"
				:src="require('@/assets/icon/icon-update.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="批量加价率" fontSize="14px"
				@btnclick="batchMarkup" :src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('approval')" backgroundColor="#FFF" title="审核" fontSize="14px"
				@btnclick="verifyQuota" :src="require('@/assets/icon/shen.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('approval')" backgroundColor="#FFF" title="弃审" fontSize="14px"
				@btnclick="unVerifyQuota" :src="require('@/assets/icon/shua.png')">
			</Commonbtn>
			<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="exportQuotaCustomer"
				:src="require('@/assets/icon/daoc.png')">
			</Commonbtn>
			<Commonbtn v-if="auth.includes('edit')" backgroundColor="#FFF" title="含税指标系数设置" fontSize="14px"
				@btnclick="markupRate" :src="require('@/assets/icon/icon-add.png')">
			</Commonbtn>
		</div>
		<div class="Table">
			<Commontable ref="refTableCenter" @onRowClick="onRowClick" width="1000px" colnum=7 color
				:tableData="tableData" :headerData="headerData" height="100%"
				@handleSelectionChange="(e)=>selectValues = e">
			</Commontable>
			<div class="pagination">
				<Pagination ref="invPagination" type='allColor' :pageSize="query.pageSize"
					@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
				</Pagination>
			</div>
		</div>
		<!---->
		<DialogFrom width="1060px" title="修改" :OKASCAN="true" :dialogVisible="dialogShow" @cancel="cancelEditor"
			@dialogOK="dialogOKEditor">
			<div class="dialog-form" v-if="dataInfo">
				<div class="dialog-info">
					<div class="info-item" v-for="(item,index) in editInfo" :key="index">
						<div class="info-key">
							{{item.title}}：
						</div>
						<div class="info-val" v-if="index===5">
							<input class="inputval" type="text" v-model="dataInfo[item.key]">倍
							<button class="btnselect" @click="handSumAll">
								确定
							</button>
						</div>
						<div class="info-val" v-else>
							{{dataInfo[item.key]}}
						</div>
					</div>
				</div>

				<div class="dialog-card" style="display:flex;justify-content: space-between;align-items: center;">
					<div class="card-title">
						年度指标汇总：{{dataInfo.totalAll?dataInfo.totalAll:dataInfo.YearQuota}}
					</div>
					<div class="card-info" style="height: 40px;padding-right: 66px;">
						<div class="info-item">
							<div class="info-key" style="min-width:70px;">
								修订日期：
							</div>
							<div class="info-val">
								<el-date-picker v-model="dataInfo.ReviseTime" class="inputval" type="date"
									value-format="yyyy-MM-dd" :editable="false" placeholder="选择日期时间" />
							</div>
						</div>
					</div>
				</div>
				<div class="dialog-card" v-for="(item,index) in editForm" :key="index">
					<div class="card-title">
						第{{quarterList[index]}}季度
					</div>
					<div class="card-info">
						<div class="info-item" v-for="(item1,index1) in item" :key="index1">
							<div class="info-key">
								{{item1.title}}
							</div>
							<div class="info-val">
								<input class="inputval" type="text" v-model="dataInfo[item1.key]">
							</div>
						</div>
					</div>
				</div>
			</div>
		</DialogFrom>

		<!--批量加价率-->
		<DialogFrom width="1000px" title="批量修改加价率" :OKASCAN="true" :dialogVisible="batchShow" @cancel="batchCancel"
			@dialogOK="batchOk">
			<div class="dialog-form">
				<div class="dialog-card">
					<div class="card-title">
						加价率
					</div>
					<div class="card-info" style="justify-content: flex-start;">
						<div class="info-item">
							<div class="info-key">
								加价率：
							</div>
							<div class="info-val">
								<input class="inputval" type="number" placeholder="请输入加价率数字"
									v-model="dataTemp.markupRate" style="margin-right: 4px;">倍
							</div>
						</div>
						<div class="info-item">
							<div class="info-key">
								修订日期：
							</div>
							<div class="info-val">
								<el-date-picker class="inputval" v-model="dataTemp.reviseTime" type="date"
									:editable="false" placeholder="选择修订日期" value-format="yyyy-MM-dd" />
							</div>
						</div>
					</div>
				</div>
			</div>
		</DialogFrom>


		<!--含税指标系数设置-->
		<DialogFrom width="1000px" title="含税指标系数设置" :OKASCAN="true" :dialogVisible="rateShow" @cancel="rateCancel"
			@dialogOK="rateOk">
			<div class="dialog-form">
				<div class="dialog-card">
					<div class="card-title">
						加价率
					</div>
					<div class="card-info">
						<div class="info-item" v-for="(item,index) in markupRateList" :key="index">
							<div class="info-key">
								{{item.InvClassName}}：
							</div>
							<div class="info-val">
								<input class="inputval" type="number" placeholder="请输入加价率数字" v-model="item.MarkupRate">
							</div>
						</div>
					</div>
				</div>
			</div>
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../../components/common-btn.vue'
	import DialogFrom from '../../../../../../../components/dialog-from.vue'
	import Pagination from '../../../../../../../components/pagination.vue'
	import CommonbtnUpLoad from './../../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../../components/common-table.vue'
	import Dialog from '../../../../../../../components/dialog.vue'
	import FromArr from '../FormData/FromArrSummary'
	import {
		editInfo,
		editForm
	} from '../FormData/FromArrEditorSummary'
	import headerData from '../TableData/headerData2'
	import utils from "../../../../../../../common/utils";
	import {
		InventoryClassList,
		Status
	} from '@/api/home'
	import {
		HelperLEVEL1_5
	} from '@/api/channel'
	import {
		GetQuotaCustomerVerifyList,
		GetQuotaCustomerVerifyInfo,
		EditQuotaCustomerVerify,
		VerifyQuotaCustomer,
		UnVerifyQuotaCustomer,
		ExportQuotaCustomerVerify,
		GetSetMarkupRate,
		SetMarkupRate,
		BatchEdit
	} from '@/api/newsapi'
	export default {
		props: {
			auth: Array
		},
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Dialog,
			Pagination,
			CommonbtnUpLoad,
			Commontable
		},
		data() {
			return {
				total: 0,
				query: {
					pageIndex: 1,
					pageSize: 10
				},
				dialogShow: false,
				FromArr: [],
				tableCurr: null,
				tableData: [],
				headerData: [],
				tableDatadrjg: [],
				dialogVisiblesdrjg: false,
				downlist: [],
				selectValues: [],
				dataInfo: null,
				editInfo: editInfo,
				editForm: [],
				quarterList: ['一', '二', '三', '四'],
				rateShow: false,
				markupRateList: [], //加价率
				batchShow: false,
				dataTemp: {
					markupRate: '',
					reviseTime: ''
				}
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.editForm = JSON.parse(JSON.stringify(editForm))
			this.inventoryClassList();
			this.HelperLEVEL1_5();
			this.getData();
			this.status();
		},
		methods: {
			batchCancel() {
				this.batchShow = false;
			},
			async batchOk() {
				if (!this.dataTemp.markupRate) {
					this.$message.error('加价率不能为空！');
					return;
				}
				if (!this.dataTemp.reviseTime) {
					this.$message.error('修订日期不能为空！');
					return;
				}
				let {
					code,
					data,
					message
				} = await BatchEdit({
					iDs: this.selectValues.map(item => item.ID),
					markupRate: this.dataTemp.markupRate,
					reviseTime: this.dataTemp.reviseTime
				})
				if (code == 0) {
					this.$message.success('修改成功！');
					this.batchShow = false;
					this.getData();
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message({
							type: 'error',
							message: message
						});
					}
				}
			},
			//批量加价率
			batchMarkup() {
				if (!this.selectValues.length) {
					this.$message.error('请先选择数据');
					return;
				}
				this.dataTemp = {
					markupRate: '',
					reviseTime: ''
				}
				this.batchShow = true;
			},
			//含税指标系数设置
			async markupRate() {
				let {
					code,
					data
				} = await GetSetMarkupRate({})
				if (code == 0) {
					this.rateShow = true;
					this.markupRateList = data;
				}
			},
			rateCancel() {
				this.rateShow = false;
			},
			//提交
			async rateOk() {
				let {
					code,
					data,
					message
				} = await SetMarkupRate(this.markupRateList);
				if (code == 0) {
					this.rateShow = false;
					this.$message.success('添加成功！')
				} else {
					this.$message.error(message)
				}
			},
			async getData() {
				this.query.year = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue ? this.FromArr[1].modelvalue.join(',') : '';
				this.query.LEVEL1_5 = this.FromArr[2].modelvalue;
				this.query.cusName = this.FromArr[3].modelvalue;
				this.query.ApplyCode = this.FromArr[4].modelvalue;
				this.query.Status = this.FromArr[5].modelvalue;

				let {
					code,
					data
				} = await GetQuotaCustomerVerifyList(this.query)
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data.map(item => {
						item.ReviseTime = item.ReviseTime ? item.ReviseTime.substring(0, 10) : '';
						return item;
					});
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArr[0].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							label: item.InvClassName,
							value: item.InvClass,
						}
						this.FromArr[1].options.push(obj)
					})
					let date = new Date()
					let yearArr = [
						date.getFullYear() - 1,
						date.getFullYear(),
						date.getFullYear() + 1
					]
					yearArr.map((item, index) => {
						let obj = {
							key: item,
							value: item
						}
						this.FromArr[0].options.push(obj)
					})
				} else {
					this.$message.error('公司加载失败')
				}
			},
			// 产品分类L1.5
			async HelperLEVEL1_5() {
				let {
					code,
					data,
					message
				} = await HelperLEVEL1_5({})
				if (code == 0) {
					this.FromArr[2].options = []
					data.forEach((item, index) => {
						if (item.key && item.value) {
							let obj = {
								key: item.key,
								value: item.value
							}
							this.FromArr[2].options.push(obj)
						}
					})
				}
			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.FromArr[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[5].options.push(obj)
					})
				}
			},
			handSearch() {
				this.query.pageIndex = 1;
				this.getData();
			},
			handReset() {
				this.query = {
					pageIndex: 1,
					pageSize: 10
				};
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
				})
				this.getData();
			},
			onRowClick(val) {
				this.tableCurr = val.ID;
			},
			//审核
			async verifyQuota() {
				if (!this.selectValues.length) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					msg
				} = await VerifyQuotaCustomer({
					IDs: this.selectValues.map(item => item.ID)
				})
				if (code == 0) {
					this.$message.success('审核成功')
					this.getData();
				} else if (code === 1 && data.length) {
					this.$alert(`${data.join('<br/>')}`, '提示', {
						dangerouslyUseHTMLString: true,
						showConfirmButton: false
					});
				} else {
					this.$message.error(msg)
				}
				loading.close();
			},
			//弃审
			async unVerifyQuota() {
				if (!this.selectValues.length) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					msg
				} = await UnVerifyQuotaCustomer({
					IDs: this.selectValues.map(item => item.ID)
				})
				if (code == 0) {
					this.getData();
					this.$message.success('弃审成功')
				} else if (code === 1 && data.length) {
					this.$alert(`${data.join('<br/>')}`, '提示', {
						dangerouslyUseHTMLString: true,
						showConfirmButton: false
					});
				} else {
					this.$message.error(msg)
				}
				loading.close();
			},
			//编辑
			async update() {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data
				} = await GetQuotaCustomerVerifyInfo({
					id: this.tableCurr
				})
				if (code == 0) {
					this.dataInfo = data.data;
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//取消编辑
			cancelEditor() {
				this.dialogShow = false;
				setTimeout(() => {
					this.dataInfo = null;
					this.tableCurr = null;
					this.$forceUpdate();
				}, 200)
			},
			async dialogOKEditor() {
				console.log(this.dataInfo);
				let {
					code,
					data,
					message
				} = await EditQuotaCustomerVerify(this.dataInfo)
				if (code == 0) {
					this.$message.success('已修改');
					this.cancelEditor();
					this.handSearch();
				} else {
					this.$message.error(message);
				}
			},
			// 导出
			async exportQuotaCustomer() {
				this.query.year = this.FromArr[0].modelvalue;
				this.query.invClass = this.FromArr[1].modelvalue ? this.FromArr[1].modelvalue.join(',') : '';
				this.query.LEVEL1_5 = this.FromArr[2].modelvalue;
				this.query.cusName = this.FromArr[3].modelvalue;
				this.query.ApplyCode = this.FromArr[4].modelvalue;
				this.query.Status = this.FromArr[5].modelvalue;
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportQuotaCustomerVerify(this.query)
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `经销商指标审批${str}`, "xlsx")
					loading.close();
				} else {
					// 返回json
					this.$message.warning('导出失败');
					loading.close();
				}
				loading.close()
			},
			handSumAll() {
				if (!this.dataInfo.MarkupRate) {
					this.$message.warning('加价率不能为空');
					return;
				}
				let markupRate = Number(this.dataInfo.MarkupRate); //加价率
				let totalAll = 0;
				this.editForm.forEach(item => {
					item.forEach(item1 => {
						let num = Number((markupRate * Number(this.dataInfo[item1.key +
							'_Org'])).toFixed(0)) ? Number((markupRate * Number(this.dataInfo[item1
							.key + '_Org'])).toFixed(0)) : '';
						this.dataInfo[item1.key] = num;
						totalAll = totalAll + (this.dataInfo[item1.key] ? this.dataInfo[item1.key] : 0);
					})
				})
				this.dataInfo.totalAll = totalAll.toFixed(0);
			},
			handleCurrentChange(e) {
				this.query.pageIndex = e
				this.getData()
			},
			handleSizeChange(e) {
				this.query.pageSize = e
				this.getData()
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 160px;
		margin: 16px 0px 8px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 0px;
		}
	}

	.BottomTable {
		margin-bottom: 14px;
	}

	.custom-table {
		cursor: pointer;
		user-select: none;
		margin-bottom: 16px;
		box-sizing: border-box;

		.table-header {
			height: 40px;
			background: #00266D;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0px 16px;

			span {
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 400;
				color: #FFFFFF;
			}
		}

		.red {
			background: #E71D43;
		}

		.table-title {
			display: flex;

			.title-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.title-item:last-child {
				border-right: 0px;
			}
		}

		.table-value {
			display: flex;

			.value-item {
				flex: 1;
				font-size: 14px;
				font-family: Alibaba PuHuiTi 2.0-55 Regular, Alibaba PuHuiTi 20;
				font-weight: 500;
				color: #333333;
				height: 40px;
				line-height: 40px;
				text-align: center;
				border-bottom: 1px solid #EEEEEE;
				border-right: 1px solid #EEEEEE;
				box-sizing: border-box;
			}

			.value-item:last-child {
				border-right: 0px;
			}
		}
	}

	.select-table {
		border: 1px solid #00266D;
	}



	.dialog-form {
		.dialog-info {
			display: flex;
			align-items: stretch;
			flex-wrap: wrap;
			justify-content: space-between;
			height: 100px;

			.info-item {
				width: 33.33%;
				display: flex;
				align-items: center;

				.info-key {
					font-size: 14px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #666666;
				}

				.info-val {
					font-size: 14px;
					font-family: PingFang SC-Regular, PingFang SC;
					font-weight: 400;
					color: #333333;

					.inputval {
						width: 60px;
						height: 32px;
						line-height: 32px;
						border-radius: 2px;
						border: 1px solid #E5E5E5;
						padding: 0px 16px;
						margin-right: 8px;
					}

					.btnselect {
						width: 64px;
						height: 32px;
						border: 1px solid #e6e6e6;
						border-radius: 2px;
						text-align: center;
						// line-height: 32px;
						color: #fff;
						background-color: #e71d43;
						display: inline-block;
						margin-left: 10px;
						cursor: pointer;
						opacity: 1;
					}

					.btnselect:hover {
						background-color: #e03f5d;
					}

					.btnselect:active {
						background-color: #c01837;
					}
				}
			}
		}

		.dialog-card {
			padding: 16px;
			border: 1px solid #EEEEEE;
			margin-bottom: 16px;

			.card-title {
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
				position: relative;
			}

			.card-title::before {
				content: " ";
				position: absolute;
				left: -16px;
				top: 2px;
				border-left: 4px solid #E71D43;
				height: 16px;
			}

			.card-info {
				display: flex;
				align-items: stretch;
				flex-wrap: wrap;
				justify-content: space-between;
				height: 60px;

				.info-item {
					width: 33.33%;
					display: flex;
					align-items: center;

					.info-key {
						font-size: 14px;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #666666;
					}

					.info-val {

						.inputval {
							width: 160px;
							height: 32px;
							line-height: 32px;
							border-radius: 2px;
							border: 1px solid #E5E5E5;
							padding: 0px 16px;


							/deep/.el-input__inner {
								border: none !important;
								height: 32px;
								line-height: 32px;
								padding: 0px;
							}

							/deep/.el-input__prefix {
								display: none;
							}

							/deep/.el-input__suffix {
								display: none;
							}
						}
					}
				}
			}
		}
	}
</style>